import { render, staticRenderFns } from "./LongBox.vue?vue&type=template&id=445ecf67&scoped=true"
import script from "./LongBox.vue?vue&type=script&lang=js"
export * from "./LongBox.vue?vue&type=script&lang=js"
import style0 from "./LongBox.vue?vue&type=style&index=0&id=445ecf67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ecf67",
  null
  
)

export default component.exports